import { useCallback, useState } from "react";

type SelectedVolunteer = {
  associationId: string;
  name: string;
};

type Options = {
  onSave?: () => void;
};

export function useAssociationCommunicationRecordsDialog({ onSave }: Options = {}) {
  const [selectedVolunteer, setSelectedVolunteer] =
    useState<SelectedVolunteer | null>(null);

  const openCommunicationRecords = useCallback((volunteer: SelectedVolunteer) => {
    setSelectedVolunteer(volunteer);
  }, []);

  const closeCommunicationRecords = useCallback(() => {
    setSelectedVolunteer(null);
  }, []);

  return {
    openCommunicationRecords,
    communicationRecordsDialogProps: {
      open: !!selectedVolunteer,
      onClose: closeCommunicationRecords,
      title: selectedVolunteer?.name ?? "מתנדב",
      associationId: selectedVolunteer?.associationId,
      type: "volunteer" as const,
      onSave,
    },
  };
}
